import { useQuery } from 'react-query';
import {
  RiGroupLine,
  RiUserAddLine,
  RiSmartphoneLine,
  RiRadioButtonLine,
  RiHeartLine,
  RiRepeatLine,
  RiFileTextLine,
} from 'react-icons/ri';

import WidgetShell from '../WidgetShell';
import Spinner from '../../Spinner';
import { useAuth } from '../../../contexts/auth-context';
import axios from '../../../utils/axios';

const STATS = [
  {
    key: 'totalUsers',
    icon: RiGroupLine,
    label: 'Usuários no sistema',
    color: 'text-blue-500',
    bg: 'bg-blue-500/10',
  },
  {
    key: 'newUsersToday',
    icon: RiUserAddLine,
    label: 'Novos usuários (24h)',
    color: 'text-sky-500',
    bg: 'bg-sky-500/10',
  },
  {
    key: 'androidDevices',
    icon: RiSmartphoneLine,
    label: 'Dispositivos Android',
    color: 'text-green-500',
    bg: 'bg-green-500/10',
  },
  {
    key: 'onlineNow',
    icon: RiRadioButtonLine,
    label: 'Online agora',
    color: 'text-emerald-500',
    bg: 'bg-emerald-500/10',
  },
  {
    key: 'postsToday',
    icon: RiFileTextLine,
    label: 'Postagens (24h)',
    color: 'text-indigo-500',
    bg: 'bg-indigo-500/10',
  },
  {
    key: 'likesToday',
    icon: RiHeartLine,
    label: 'Curtidas (24h)',
    color: 'text-rose-500',
    bg: 'bg-rose-500/10',
  },
  {
    key: 'sharesToday',
    icon: RiRepeatLine,
    label: 'Compartilhamentos (24h)',
    color: 'text-purple-500',
    bg: 'bg-purple-500/10',
  },
];

const AdminStatsWidget = () => {
  const { user } = useAuth();

  const { data, isLoading } = useQuery(
    ['admin-quick-stats'],
    async () => {
      const response = await axios.get('/api/admin/quick-stats');
      return response.data;
    },
    {
      staleTime: 60 * 1000,
      refetchInterval: 60 * 1000,
      refetchOnWindowFocus: true,
      enabled: Boolean(user?.isAdmin),
    }
  );

  if (!user?.isAdmin) return null;

  return (
    <WidgetShell title="Painel Admin">
      {isLoading ? (
        <div className="flex justify-center py-4">
          <Spinner size="sm" />
        </div>
      ) : (
        <ul className="divide-y divide-on-surface/10">
          {STATS.map(({ key, icon: Icon, label, color, bg }) => (
            <li key={key} className="flex items-center gap-3 px-3 py-2">
              <span className={`${bg} ${color} rounded-lg p-1.5 shrink-0`}>
                <Icon size={16} />
              </span>
              <span className="flex-1 text-sm text-on-surface/70">{label}</span>
              <span className="font-semibold text-on-surface tabular-nums text-sm">
                {data?.[key] ?? '—'}
              </span>
            </li>
          ))}
        </ul>
      )}
    </WidgetShell>
  );
};

export default AdminStatsWidget;
